import { Directive, ViewContainerRef, Input, OnInit, ComponentFactoryResolver, ChangeDetectorRef, Type } from '@angular/core';



@Directive({
  selector: '[smaDynamicHost]',
})
export class DynamicHostDirective implements OnInit {
  @Input('smaDynamicHost') component: Type<any>;
  @Input('duan') duan: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    if (this.component != null) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.component,
      );
      this.viewContainerRef.clear();
      const cmp = this.viewContainerRef.createComponent(componentFactory);
      //cmp.instance.duanSelected = this.duan;
      this.cdr.detectChanges();
    }
    
  }
}
